import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import QueryWorkitem from "../../../../../modules/@cloudpivot/flow-center/src/components/pc/components/query-condition/query-workitem.vue";
import StaffSelector from "../../../../../modules/@cloudpivot/form/src/common/components/form-staff-selector/pc/staff-selector.vue";
import { Badge, Table, Carousel, Form, Row, Col, Input, Select, DatePicker, Button, Modal, Cascader, Tree, Icon, Pagination, } from "@h3/antd-vue";
let modal = class modal extends Vue {
    constructor() {
        super(...arguments);
        this.contentList = [
            {
                title: "How to Enable Permissions",
                content: "If you have the administrator permission, you have the full control. If you do not have the full control, you cannot perform corresponding operations on the file. If you have the administrator permission, you have all the permissions on the file.",
            },
            {
                title: "How to Enable Permissions",
                content: "If you have the administrator permission, you have the full control. If you do not have the full control, you cannot perform corresponding operations on the file. If you have the administrator permission, you have all the permissions on the file.",
            },
            {
                title: "How to Enable Permissions",
                content: "If you have the administrator permission, you have the full control. If you do not have the full control, you cannot perform corresponding operations on the file. If you have the administrator permission, you have all the permissions on the file.",
            },
        ];
    }
    onCancel() {
        this.$emit("changemodal");
    }
};
tslib_1.__decorate([
    Prop()
], modal.prototype, "isShowModal", void 0);
modal = tslib_1.__decorate([
    Component({
        name: "modal",
        components: {
            StaffSelector,
            QueryWorkitem,
            ABadge: Badge,
            ATable: Table,
            ACarousel: Carousel,
            AForm: Form,
            AFormItem: Form.Item,
            ARow: Row,
            ACol: Col,
            AInput: Input,
            AInputSearch: Input.Search,
            ASelect: Select,
            ASelectOption: Select.Option,
            ADatePicker: DatePicker,
            AButton: Button,
            AModal: Modal,
            ACascader: Cascader,
            ADirectoryTree: Tree.DirectoryTree,
            AIcon: Icon,
            APagination: Pagination,
        },
    })
], modal);
export default modal;
